import type { ProductType } from '../../../types';
import useGetQuoteDetails from '../../workflows/bind-quote/hooks/useGetQuoteDetails';
import { QuoteDynamicSecurityAssessmentForm } from '../../agencies/quotes/PrimeX/securityQuestions/QuoteDynamicSecurityAssessmentForm';

const SecurityQuestionsResolver = ({
  quoteId,
  productType,
  isEditable = true,
  withDefaults = false,
}: {
  quoteId: string;
  productType: ProductType;
  isEditable?: boolean;
  withDefaults?: boolean;
}) => {
  const quoteDetails = useGetQuoteDetails({ productType, quoteId });

  if (quoteDetails.isLoading || !quoteDetails.data) {
    return null;
  }

  return (
    <QuoteDynamicSecurityAssessmentForm
      productType={productType as ProductType}
      quoteId={quoteId}
      accountId={quoteDetails?.data?.uiData?.accountId ?? ''}
      isEditable={isEditable}
      withDefaults={withDefaults}
    />
  );
};

export default SecurityQuestionsResolver;
